import React from 'react';

import { translate } from '../../../i18n/I18nProvider';
import formatDate from '../../../utils/formatDate';
import TableActionButtons from './TableActionButtons';
import CreatedBy from './CreatedBy';
import Optional from '../../../utils/optional';
import {
  doesArrayHasLength,
  isArray,
  isDefined,
  isObject,
  isString,
  isUndefined
} from '../../../utils/isDefined';
import createTableFilterSelectOptions from '../../../utils/createTableFilterSelectOptions';
import StatusCell from '../../../partials/statusCell/StatusCell';
import STATUS_BOX_OPTIONS from '../../../consts/statusBoxOptions';
import pickOptionsForStatusCell from '../../../partials/statusCell/actions/pickOptionsForStatusCell';
import searchCaseInsensitive from '../../../utils/searchCaseInsensitive';
import { translateType, translateValue } from '../actions/translateActions';

const tableColumns = client => {
  const columns = [
    {
      render: rowData => <TableActionButtons data={rowData} client={client} />,
      disableClick: true,
      sorting: false,
      filtering: false,
      customFilterAndSearch: (term, rowData) => {
        return searchInObject(rowData.specification, term);
      },
      width: '50px'
    },
    {
      title: `${translate('BUTTON.ORDER')} ID`,
      untranslatedTitle: true,
      field: 'order_id',
      render: rowData => Number(rowData.order_id)
    },
    {
      title: 'CLIENT',
      render: rowData => Optional(rowData.client?.name).or(''),
      field: 'client.name',
      hideForUserView: true
    },
    {
      title: 'IDENTIFIER',
      field: 'type',
      render: rowData => translateCellArrayValues(rowData.type, translateType)
    },
    {
      title: 'ACTION',
      field: 'action',
      render: rowData =>
        translateCellArrayValues(rowData.action, translateValue)
    },
    {
      title: 'STATUS',
      render: rowData => (
        <StatusCell
          {...pickOptionsForStatusCell(
            STATUS_BOX_OPTIONS.ORDERS,
            rowData.status
          )}
        />
      ),
      field: 'status',
      lookup: {
        ...createTableFilterSelectOptions(STATUS_BOX_OPTIONS.ORDERS)
      }
    },
    {
      title: 'CREATED_BY',
      render: rowData => <CreatedBy data={rowData.created_by} />,
      field: 'created_by.name'
    },
    {
      title: 'CREATED_AT',
      render: rowData => formatDate(rowData.created_at),
      field: 'created_at'
    },
    {
      title: 'UPDATED_AT',
      render: rowData => formatDate(rowData.updated_at),
      field: 'updated_at'
    }
  ];

  let mappedColumns = [...columns];

  if (isDefined(client)) {
    mappedColumns = columns.filter(column =>
      isUndefined(column.hideForUserView)
    );
  }

  if (isUndefined(client)) {
    mappedColumns = columns.filter(column =>
      isUndefined(column.hideForAdminView)
    );
  }

  return mappedColumns.map((column, i) => {
    return { ...column, id: i };
  });
};

export default tableColumns;

const searchInObject = (obj, term) => {
  if (isUndefined(obj) || !isObject(obj)) {
    return false;
  }

  const valuesArray = Object.values(obj);

  const found = valuesArray
    .map(value => {
      if (isUndefined(value) || !isString(value)) {
        return false;
      }

      return searchCaseInsensitive(value, term);
    })
    .filter(el => el === true);

  return doesArrayHasLength(found);
};

const translateCellArrayValues = (data, translateFunction) => {
  return isArray(data)
    ? data.map(item => translateFunction(item)).join(', ')
    : '';
};
